import script from "./ResultTypeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultTypeSettings.vue?vue&type=script&setup=true&lang=js"

import "./ResultTypeSettings.vue?vue&type=style&index=0&id=4641fa6f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4641fa6f"]])

export default __exports__